import React, {Component, PropTypes} from 'react'
import {FormGroup, Col, FormControl, ControlLabel} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import ProgressBar from '../../Common/ProgressBar/ProgressBar'

class DoubleTextFieldTranslator extends Component {
  constructor (props) {
    super(props)
    this.state = {
      inputValue: '',
      translated: '',
      isLoading: false
    }
    this.timeout = null
    this.translate = this.translate.bind(this)
  }

  translate (value) {
    const {name, nameFa, setter} = this.props
    setter(nameFa, value)
    this.setState({inputValue: value})
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (value.length > 0) {
      this.timeout = setTimeout(() => {
        this.setState({isLoading: true})
        Actions.googleTranslate(value).then((res) => {
          setter(name, res.data.translate)
          this.setState({translated: res.data.translate, isLoading: false})
        })
      }, 700)
    }
  }

  render () {
    const {placeholder, name, nameFa} = this.props
    const {translated, isLoading} = this.state

    return (
      <div>
        <FormGroup>
          <Col componentClass={ControlLabel} xs={3} xsOffset={1}>
            {placeholder}
          </Col>
          <Col xs={7}>
            <FormControl
              name={nameFa}
              className="form-control"
              onChange={(e) => this.translate(e.target.value)}
            />
            <ProgressBar isLoading={isLoading} />
          </Col>
        </FormGroup>
        {translated &&
          <FormGroup>
            <Col componentClass={ControlLabel} xs={3} xsOffset={1}>
              ترجمه
            </Col>
            <Col xs={7}>
              <FormControl
                name={name}
                placeholder=""
                className="form-control"
                defaultValue={translated}
              />
            </Col>
          </FormGroup>
        }
      </div>
    )
  }
}

DoubleTextFieldTranslator.propTypes = {
  name: PropTypes.string.isRequired,
  nameFa: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  setter: PropTypes.func.isRequired,
  getter: PropTypes.func.isRequired
}

export default DoubleTextFieldTranslator



// WEBPACK FOOTER //
// ./src/components/HorseInfo/ImageForm/DoubleTextFieldTranslator.js